<style lang="scss" scoped>
$leftWidth: 220px;
.content-part {
  .content-left {
    width: 0;
  }

  .content-right {
    > h3 {
      left: 0;
    }

    left: 0;
  }
}

.el-checkbox--upload {
  position: absolute;
  left: 100px;
  top: 0;
  display: block;
}
</style>
<template>
  <div>
    <div class="content-part">
      <div class="content-left">
        <h2 class="clearfix right-title" style="font-size: 16px"></h2>
      </div>
      <div class="content-right min-gutter">
        <h3>新增包装层级</h3>
        <div class="hide-content show-content">
          <el-form ref="form" :rules="rules" :model="form"
                   label-width="100px" style="padding-right: 20px">
            <el-form-item label="产品编码">
              {{ formItem.productCode }}
            </el-form-item>
            <el-form-item label="货品编码">
              {{ formItem.goodsNo }}
            </el-form-item>
            <el-form-item label="产品名称">
              {{ formItem.productName }}
            </el-form-item>
            <el-form-item label="子类编码">
              {{ formItem.productSubclassCode }}
            </el-form-item>
            <el-form-item label="剂型">
              {{ formItem.productDosage }}
            </el-form-item>
            <el-form-item label="剂型规格">
              {{ formItem.productSpecification }}
            </el-form-item>
            <el-form-item label="包装层级" prop="packageRatio">
              <el-input clearable v-model="form.packageRatio" placeholder="包装层级由小到大排列，层级之间用:隔开，例如1:10:100"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" :disabled="doing"
              >保存
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {http} from '@/resources';
import methodsMixin from '@/mixins/methodsMixin';
import selectMixin from '@/mixins/dosageSelectMixin';

export default {
  name: 'packageForm',
  props: {
    formItem: Object
  },
  mixins: [methodsMixin, selectMixin],
  data() {
    let checkPackageRatio = (rule, value, callback) => {
      if (value !== '' && value !== null) {
        if (!value || value === '') callback(new Error('包装层级不能为空'));
        if (value.slice(0, 2) === "1:") {
          callback();
        } else {
          callback(new Error('包装层级必须以1:开头,请重新输入'));
        }
      } else {
        callback();
      }
    };
    return {
      form: {
        productSubclassId: '',
        packageRatio: '1:'
      },
      rules: {
        packageRatio: [{required: true, message: '请输入包装层级', trigger: 'change'}, {
          min: 1,
          max: 50,
          message: '包装层级长度最大为50位',
          trigger: 'blur'
        }, {validator: checkPackageRatio, trigger: 'blur'}]
      },
      doing: false
    };
  },
  computed: {},
  watch: {
    formItem(val) {
      if (!val.productSubclassId) return;
      this.resetForm();
      this.form = {
        productSubclassId: val.productSubclassId,
        packageRatio: '1:'
      };
    }
  },
  methods: {
    resetForm() {
      this.form = {
        productSubclassId: '',
        packageRatio: '1:'
      };
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      })
    },
    onSubmit() {
      this.$refs['form'].validate((valid) => {
        if (!valid || this.doing) {
          return false;
        }
        this.doing = true;
        http.post('/resource-code/ratio', this.form).then(res => {
          this.$notify.success({message: '新增包装层级成功'});
          this.$emit('refresh', {});
          this.resetForm();
          this.doing = false;
        }).catch(e => {
          this.$notify.error({
            duration: 2000,
            message: this.$errHandler(e)
          });
          this.doing = false;
        });
      });
    }
  }
};
</script>
